import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, LinkToggle, useBanner, BannerCookie, useGroupCheckbox } from "../../..";
import { Group } from "../../common";
const BannerGroup = (param)=>{
    let { group } = param;
    const banner = useBanner();
    const { name, description, items } = group;
    const { group: { headlineFontSize }, individualTexts: { headline, showMore, hideMore } } = banner;
    const groupCheckbox = useGroupCheckbox(group);
    return /*#__PURE__*/ _jsxs(Group, {
        legend: `${headline}: ${name}`,
        headline: /*#__PURE__*/ _jsxs(Checkbox, {
            ...groupCheckbox,
            fontSize: headlineFontSize,
            children: [
                name,
                " (",
                items.length,
                ")"
            ]
        }),
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: description
            }),
            !!items && /*#__PURE__*/ _jsx(LinkToggle, {
                showMore: showMore,
                hideMore: hideMore,
                bullets: true,
                children: items.map((cookie)=>/*#__PURE__*/ _jsx(BannerCookie, {
                        group: group,
                        cookie: cookie
                    }, cookie.id))
            })
        ]
    });
};
export { BannerGroup };
